import { SET_AFFILIATE_SETTING } from '../actions/affiliate/action_types';

export default (
  state = {
    setting: [],
  }, action,
) => {
  switch (action.type) {
    case SET_AFFILIATE_SETTING:
      return {
        ...state,
        setting: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};
